import { guestPermissionsFromClaims, isGuestEmail } from './guestAuth';
import { normalizeLocationsClaims } from './roleUtils';
import { hasMhopClaim } from './mhopCompat';

export function normalizeAuthClaims(rawClaims = {}, email = '') {
  const guest = rawClaims.guest === true || isGuestEmail(email);
  const mhop = hasMhopClaim(rawClaims);

  return {
    ...rawClaims,
    admin: rawClaims.admin || false,
    staff: rawClaims.staff || false,
    manager: rawClaims.manager || false,
    director: rawClaims.director || false,
    programManager: rawClaims.programManager || false,
    mhop,
    behavioralHealth: mhop,
    compliance: rawClaims.compliance || false,
    executive: rawClaims.executive || false,
    relief: rawClaims.relief || false,
    reliefManager: rawClaims.reliefManager || false,
    development: rawClaims.development || false,
    guest,
    guestClientProfile: rawClaims.guestClientProfile || false,
    guestAddClient: rawClaims.guestAddClient || false,
    guestPrograms: rawClaims.guestPrograms || false,
    locations: rawClaims.locations || []
  };
}

export function buildAuthContextUser(firebaseUser, rawClaims = {}) {
  const claims = normalizeAuthClaims(rawClaims, firebaseUser?.email);
  const guestPermissions = guestPermissionsFromClaims(claims);
  const mhop = hasMhopClaim(claims);

  return {
    ...firebaseUser,
    uid: firebaseUser.uid,
    email: firebaseUser.email,
    displayName: firebaseUser.displayName || '',
    claims,
    isAdmin: claims.admin === true || claims.role === 'admin',
    isStaff: claims.staff,
    isManager: claims.manager,
    isDirector: claims.director === true,
    isProgramManager: claims.programManager === true || claims.role === 'programManager',
    isMhop: mhop,
    isBehavioralHealth: mhop,
    isCompliance: claims.compliance,
    isExecutive: claims.executive,
    isGuest: claims.guest === true,
    guestPermissions,
    isOperations: claims.operations === true || claims.role === 'operations',
    isRelief: claims.relief === true,
    isReliefManager: claims.reliefManager === true,
    isDevelopment: claims.development === true,
    locations: normalizeLocationsClaims(claims.locations),
    getIdToken: (forceRefresh = false) => firebaseUser.getIdToken(forceRefresh),
    getIdTokenResult: (forceRefresh = false) => firebaseUser.getIdTokenResult(forceRefresh)
  };
}
